import { FC, useMemo } from 'react';
import { BuilderFieldError, BuilderFieldErrorProps, ErrorSign } from '../../wrappers/error/builderFieldError.component';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { AppAttachmentsProps } from 'uikit/appAttachmentsV2/AppAttachmentsV2.d';
import { AppAttachmentsV2 } from 'uikit/appAttachmentsV2/AppAttachmentsV2';
import { mergeValueWithError, parseError } from 'uikit/appAttachmentsV2/Hook-form-helpers';

export type AppAttachmentsFieldProps = AppAttachmentsProps & {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
};

export const AppAttachmentsField: FC<AppAttachmentsFieldProps> = ({
  disabled,
  labelProps,
  errorProps,
  hideInput,
  value,
  ...rest
}) => {
  const parsedError = useMemo(() => parseError(errorProps?.errors), [errorProps?.errors]);
  return (
    <BuilderFieldError errors={parsedError.generalError}>
      <BuilderFieldLabel
        {...labelProps}
        disabled={disabled}
        rightSection={!!parsedError.generalError ? <ErrorSign /> : <></>}
      >
        <AppAttachmentsV2
          disabled={disabled}
          value={mergeValueWithError(value, parsedError.fileErrors)}
          hideInput={hideInput}
          {...rest}
        />
      </BuilderFieldLabel>
    </BuilderFieldError>
  );
};
